import { Heading } from '@madpaws/design-system';
import React from 'react';

import { DEFAULT_SERVICE_JOB, SERVICE_TYPE_BY_NAME_MAPPING } from '~/common/constants/search';

import styles from './DynamicPetSitterCount.module.css';

type Props = {
  serviceSlug: string;
  sittersCount: number;
};

export const DynamicPetSitterCount = ({ serviceSlug, sittersCount }: Props): React.ReactElement => {
  const serviceJob = SERVICE_TYPE_BY_NAME_MAPPING[serviceSlug]?.serviceJob || DEFAULT_SERVICE_JOB;

  // get singular form if count less than 1
  const formattedServiceJob = sittersCount > 1 ? serviceJob : serviceJob.slice(0, -1);

  return (
    <div className={styles.root}>
      <Heading level={2}>{`${sittersCount} ${formattedServiceJob}`}</Heading>
    </div>
  );
};
